import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import FieldContainer from "../FieldContainer";
import Money from "utils/Money";
import MoneyInput from "nlib/common/MoneyInput";
import React, { useCallback } from "react";
import useDocumentContext from "hooks/useDocumentContext";

const AmountBaseField = (props) => {
  const id = "amountBase";

  const { uiTexts } = useSelector(getTextsData);

  const {
    lineItemsAmountGreaterThanDocument,
    lineItemsAmountLessThanDocument,
    documentState: { [id]: value, currency },
    setDocumentState
  } = useDocumentContext();

  const handleChange = useCallback((val) => {
    setDocumentState({ [id]: val });
  }, [setDocumentState]);

  return (
    <FieldContainer
      id={id}
      invalid={value < 0 || lineItemsAmountGreaterThanDocument || lineItemsAmountLessThanDocument}
      confidenceFields={["amountBase"]}
      label={uiTexts.subtotal}
      value={value}
      placeholder={uiTexts.enterSubtotal}
      displayValue={Money.toMoneyString(+value || 0, currency)}
      component={MoneyInput}
      currency={currency}
      onChange={handleChange}
      {...props} />
  );
};

export default React.memo(AmountBaseField);
